//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingDocumentController_findOneById,
  Response$AdminBillingDocumentController_findOneById$Status$200,
  ResponseContentType$AdminBillingDocumentController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBillingDocumentController_findOneById = (options: {
  params: Params$AdminBillingDocumentController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminBillingDocumentController_findOneById$Status$200[ResponseContentType$AdminBillingDocumentController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminBillingDocumentController_findOneById,
    Response$AdminBillingDocumentController_findOneById$Status$200[ResponseContentType$AdminBillingDocumentController_findOneById]
  >({
    method: 'AdminBillingDocumentController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
